import { forwardRef } from 'react';
import RadioInternal from './radio-internal';
const Radio = forwardRef(RadioInternal);
export default Radio;
